import { gridTableResultsActions } from '@constants/actionTypes';

const defaultState = {
  resultLookup: {},
  error: null,
  completedResultsLookup: {},
};

function calculateCellResultId(resultId, columnLength, index, prevTableRowsLength) {
  const rowIndex = Math.floor(index / columnLength);
  const cellIndex = index % columnLength;
  return `${resultId}_${rowIndex + prevTableRowsLength}_${cellIndex}`;
}
export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case gridTableResultsActions.updateResult: {
      const { messageData, columnLength, resultId, prevTableRowsLength } = action.payload;
      const { id, message } = messageData;
      const cellId = calculateCellResultId(resultId, columnLength, id, prevTableRowsLength);
      return { ...state, resultLookup: { ...state.resultLookup, [cellId]: message } };
    }

    case gridTableResultsActions.error: {
      return { ...state, error: action.payload };
    }

    case gridTableResultsActions.complete: {
      const data = action.payload;
      const { columnLength, resultId, results, prevTableRowsLength } = data;
      const newResults = {};
      results.forEach((item, index) => {
        const { answer } = item;
        newResults[calculateCellResultId(resultId, columnLength, index, prevTableRowsLength)] = answer;
      });
      const next = {
        ...state,
        completedResultsLookup: {
          ...state.completedResultsLookup,
          [resultId]: true,
        },
        resultLookup: {
          ...state.resultLookup,
          ...newResults,
        },
      };
      return next;
    }

    default:
      return state;
  }
}
